import { types as t } from 'mobx-state-tree';

import { AbstractQuestion } from './Question/abstract-question.store';
import { CompactGuideline } from './Question/CompactGuideline/compactGuideline.store';
import { Guideline } from './Question/Guideline/guideline.store';

export const QuestionGroup = t.model('QuestionGroup', {
  displayedQuestionType: t.maybe<any>(t.string),
  guideline: t.maybeNull(Guideline),
  compactGuideline: t.maybe(CompactGuideline),
  id: t.identifier,
  questionType: t.string,
  questions: t.array(AbstractQuestion),
});
